import type { FC } from "react";

import styled from "styled-components";

import { allTrackers } from "app/services/track/track";
import { DownloadButtonMenu } from "app/components/React/DownloadButtonMenu/DownloadButtonMenu";

const ExcelButtonWrapper = styled.div`
    position: relative;
`;

interface IExcelButtonProps {
    url: string;
    trackName: string;
    className?: string;
}

export const ExcelButton: FC<IExcelButtonProps> = ({ url, trackName, className }) => {
    const trackExcelDownload = () => {
        allTrackers.trackEvent("Download", "submit-ok", `${trackName}/Download Excel`);
    };

    return (
        <ExcelButtonWrapper className={className}>
            <DownloadButtonMenu
                Excel={true}
                PNG={false}
                downloadUrl={url}
                exportFunction={trackExcelDownload}
            />
        </ExcelButtonWrapper>
    );
};
